import { Page } from "components/atoms";
import React, { FC } from "react";
import styles from "./Meta.module.css";
import classNames from "classnames";
import { months } from "./meta/months";

type TPublicationTagsProps = {
    isDesktop: boolean;
    PublicationDate: string;
    ReadTime: string;
    ContentType: { ContentTypeName: string }
    ShowPublicationDateReadTimeContentType: boolean;
    DisplaySimplifiedBannerDesktop: boolean;
    DisplaySimplifiedBannerMobile: boolean;
    ShowQuickFactsSidebar: boolean;
}

export const PublicationTags: FC<TPublicationTagsProps> = ({
    PublicationDate,
    ReadTime,
    ContentType,
    ShowPublicationDateReadTimeContentType,
    ShowQuickFactsSidebar,
    isDesktop
}) => {
   
    const margin = isDesktop ? "mt-20 mb-80" : "mt-20 mb-50";

    /* Article content section | DATE, READ TIME, CONTENT TYPE */
    const timeStamp = PublicationDate?.match(/[\d]+/)[0];
    const date = timeStamp && new Date(parseInt(timeStamp));
    const dateFormatted = date && `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;


    return (
        <Page className={margin}>
            <section className={classNames({ 'col-8 m-auto': !ShowQuickFactsSidebar && isDesktop })}>
                {/* Publication Data */}
                {ShowPublicationDateReadTimeContentType &&
                        <div className={styles.content}>
                            <span>{PublicationDate && dateFormatted}</span>
                            <span>{ReadTime && ' | ' + ReadTime + ' min read'}</span>
                            <span>{ContentType && ContentType?.ContentTypeName && ' | ' + ContentType?.ContentTypeName}</span>
                        </div>
                }
            </section>
        </Page>
    );
}